import { render, staticRenderFns } from "./subSidebar.vue?vue&type=template&id=c6621506&scoped=true&lang=html"
import script from "./subSidebar.vue?vue&type=script&lang=js"
export * from "./subSidebar.vue?vue&type=script&lang=js"
import style0 from "./subSidebar.vue?vue&type=style&index=0&id=c6621506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6621506",
  null
  
)

export default component.exports